import styled, { css } from 'styled-components';
import { MainBtn } from 'components/Buttons';

interface IHeader {
  isReduced: boolean;
}

export const HeaderContainerWrapper = styled.div<IHeader>`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  border-bottom: 1px solid var(--primary-color);

  ${({ isReduced }) => css`
    padding: ${isReduced ? '0' : '5px 20px'};
  `}

  @media (max-width: 768px) {
    display: none;
  }

  .logo {
    width: 180px;
    cursor: pointer;
  }

  .reduced-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }

  @media only screen and (min-width: 1201px) {
    display: flex;
  }
`;

export const NavBarContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 28px;

  a {
    text-decoration: none;

    display: block;
    position: relative;
    color: var(--primary-color);
    font-family: 'Inter';
    text-decoration: none;
    cursor: pointer;
    font-size: 15px;

    &::before {
      content: '';
      background-color: var(--primary-color);
      width: 4px;
      opacity: 0;
      height: 3px;
      display: block;
      border-radius: 0;
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: scaleX(1) translateX(-300%);
      transition: all 0.3s ease;
      border-radius: 0.7px;
    }

    :hover {
      &::before {
        transform: scaleX(12) translateX(-10%);
        opacity: 1;
      }
    }

    &.active {
      &::before {
        transform: scaleX(12) translateX(-10%);
        opacity: 1;
      }
    }
  }

  span {
    color: var(--primary-color);
    font-family: 'Inter';
    text-decoration: none;
    cursor: pointer;
    font-size: 15px;
  }

  .my-course {
    display: inline-block;
    position: relative;

    .selected {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .arrow-course {
      height: 20px;
      width: 30px;
      transform: rotate(270deg);
    }
  }
`;

export const ProfileMenuContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;

  p {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 15ch;
    color: var(--primary-color);
    font-family: 'Inter';
  }

  img {
    height: 37px;
    width: 37px;
    border: 3px solid var(--primary-color);
    border-radius: 50%;
    cursor: pointer;
  }
`;

interface IOpenDrawer {
  open: boolean;
}

export const HomeWrapper = styled.div`
  display: none;

  img {
    cursor: pointer;
  }

  @media (max-width: 1200px) {
    display: flex;
    justify-content: space-between;
    padding: 3.4% 4%;
  }

  @media only screen and (min-width: 1201px) {
    display: none;
  }
`;

export const MenuBackgroundOpacity = styled.div<IOpenDrawer>`
  ${({ open }) => css`
    display: ${open ? 'flex' : 'none'};
    width: ${open ? '100%' : '0'};
  `}

  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  z-index: 4;
  left: 0;
  top: 0;
`;

export const NotRegisterHeader = styled.div`
  border-bottom: 1px solid var(--primary-color);
  background-color: #fff;

  @media (max-width: 768px) {
    display: none;
  }

  > div {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 5px 0;
  }

  img {
    width: 180px;
    cursor: pointer;
  }

  .buttons-wrapper {
    display: flex;
    gap: 12px;
  }
`;

export const NotRegisterHeaderResponsive = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    border-bottom: 1px solid var(--primary-color);
  }

  img {
    cursor: pointer;
  }
`;

export const HeaderMainBtn = styled(MainBtn)`
  .icon {
    width: 15px;
    height: 15px;
  }
`;
